import React, { memo } from 'react';
import { Button } from 'antd';
import styles from './KanbanBoard.module.scss';

const BoardTaskCard = memo(function BoardTaskCard({ task, canEditBoard, onDragStart }) {
    const tags = Array.isArray(task.tags)
        ? task.tags.filter((tag) => typeof tag?.title === 'string' && tag.title.trim() !== '')
        : [];

    return (
        <div
            className={`${styles.card} ${
                task.responseState === 'waiting_staff'
                    ? styles.cardWaitingStaff
                    : task.responseState === 'waiting_partner'
                        ? styles.cardWaitingPartner
                        : ''
            } ${task.terminalPaymentBlocked ? styles.cardTerminalPaymentBlocked : ''}`}
            draggable={canEditBoard}
            onDragStart={(e) => onDragStart(e, task.id)}
        >
            <div className={styles.cardTop}>
                <div className={styles.cardId}>#{task.id}</div>
                <div className={styles.cardPriority}>{task.priority}</div>
            </div>

            <div className={styles.cardTitle}>{task.title}</div>

            {tags.length > 0 && (
                <div className={styles.cardTags} role="list" aria-label="Теги заявки">
                    {tags.map((tag) => (
                        <span
                            key={tag.id ?? tag.title}
                            className={styles.cardTag}
                            role="listitem"
                            style={{ backgroundColor: tag.backgroundColor || '#e0f2fe' }}
                        >
                            {tag.title}
                        </span>
                    ))}
                </div>
            )}

            {task.terminalPaymentBlocked ? (
                <div className={styles.terminalPaymentBadge}>
                    Терминал не принимает оплаты
                </div>
            ) : null}

            {task.rating?.score ? (
                <div className={styles.ratingBadge}>
                    Оценка {task.rating.score}/5
                </div>
            ) : null}

            {task.taskKindLabel && task.taskKind !== 'common' ? (
                <div className={styles.cardMeta}>
                    <div className={styles.metaRow}>
                        <span className={styles.metaLabel}>Тип</span>
                        <span className={styles.metaValue}>{task.taskKindLabel}</span>
                    </div>
                </div>
            ) : null}

            <div className={styles.cardMeta}>
                {task.companyAddress ? (
                    <div className={styles.metaRow}>
                        <span className={styles.metaLabel}>Адрес</span>
                        <span className={`${styles.metaValue} ${styles.cardAddress}`}>{task.companyAddress}</span>
                    </div>
                ) : null}

                <div className={styles.metaRow}>
                    <span className={styles.metaLabel}>Автор</span>
                    <span className={styles.metaValue}>{task.author || 'Не указан'}</span>
                </div>

                {task.assignees ? (
                    <div className={styles.metaRow}>
                        <span className={styles.metaLabel}>Исполнитель</span>
                        <span className={styles.metaValue}>{task.assignees}</span>
                    </div>
                ) : null}

                {task.team ? (
                    <div className={styles.metaRow}>
                        <span className={styles.metaLabel}>Команда</span>
                        <span className={styles.metaValue}>{task.team}</span>
                    </div>
                ) : null}

                {task.terminalNumber ? (
                    <div className={styles.metaRow}>
                        <span className={styles.metaLabel}>Терминал</span>
                        <span className={styles.metaValue}>{task.terminalNumber}</span>
                    </div>
                ) : null}

                {task.contactPhone ? (
                    <div className={styles.metaRow}>
                        <span className={styles.metaLabel}>Телефон</span>
                        <span className={styles.metaValue}>{task.contactPhone}</span>
                    </div>
                ) : null}

                <div className={styles.metaRow}>
                    <span className={styles.metaLabel}>Создана</span>
                    <span className={styles.metaValue}>{task.dateCreate}</span>
                </div>

                <div className={styles.metaRow}>
                    <span className={styles.metaLabel}>Активность</span>
                    <span className={styles.metaValue}>{task.dateLastMess}</span>
                </div>
            </div>

            <div className={styles.detailsActions}>
                <Button href={`/task/${task.id}`} className={styles.detailsBtn}>
                    Подробнее
                </Button>
                <Button
                    href={`/task/${task.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.detailsNewTab}
                >
                    Новая вкладка
                </Button>
            </div>
        </div>
    );
});

export default memo(function BoardTaskList({ tasks, page, pageSize, canEditBoard, onDragStart }) {
    const visible = tasks.slice((page - 1) * pageSize, page * pageSize);

    return (
        <div className={styles.cards}>
            {visible.length === 0 ? (
                <div className={styles.emptyColumnState}>Нет задач по выбранному фильтру</div>
            ) : visible.map((task) => (
                <BoardTaskCard key={task.id} task={task} canEditBoard={canEditBoard} onDragStart={onDragStart} />
            ))}
        </div>
    );
});
